/**
 * User: ivanm
 * Layout view used as the main view for the registration main page
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("registration-templates/registrationModule.tmpl");
    var RegistrationMainLayout = {};

    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        RegistrationMainLayout = Marionette.Layout.extend({
            template: template,
            className: 'reg',
            regions: {
                mainRegion: '.registration-main-region'
            }
        });
    });
    return RegistrationMainLayout;
});